/** Minimal Web Audio SFX — PERF-07 */
let ctx;
let enabled = true;

export function setAudioOn(on) {
  enabled = on;
}

export function getAudioOn() {
  return enabled;
}

function ensureCtx() {
  if (!ctx) ctx = new AudioContext();
  return ctx;
}

function beep(freq, dur = 0.05, type = 'sine') {
  if (!enabled) return;
  const c = ensureCtx();
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.value = freq;
  g.gain.value = 0.08;
  o.connect(g);
  g.connect(c.destination);
  o.start();
  o.stop(c.currentTime + dur);
}

export function sfxCorrect() {
  beep(880, 0.06);
}

export function sfxWrong() {
  beep(180, 0.08, 'square');
}

export function sfxComplete() {
  beep(523, 0.08);
  setTimeout(() => beep(659, 0.1), 70);
}

export async function unlockAudio() {
  const c = ensureCtx();
  if (c.state === 'suspended') await c.resume();
}
